export default __webpack_public_path__ + "media/images/void-a9c15ae00440e4b0b3373fd738a29c33.png";